<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
<!--                <div class="form-group">-->
<!--                    <label>Expected Date of Delivery</label>-->
<!--                    <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="expectedDateOfDelivery"-->
<!--                                 :initialiseDate="initialiseExpectedDate"-->
<!--                                 @dateChange="onExpectedDateOfDeliverySelect"></date-picker>-->
<!--                </div>-->
                <div class="text-danger" v-show="!loading">
                    {{sequenceNumberDuplicationErrorMessage}}
                </div>
                <div class="table-responsive pt-4" v-show="!loading">
                    <table class="table table-hover mb-0">
                        <thead>
                        <tr>
                            <th>Order #</th>
                            <th>Customer</th>
                            <th>Order Date</th>
                            <th>Expected Date Of Delivery</th>
                            <th>Ship Number</th>
                            <th>Driver</th>
                            <th>Customer Purchase Order Number</th>
                            <th>SBO</th>
                            <th>Total</th>
                            <th>Status</th>
                            <th>Sequence</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(order, index) in orders" :key="index">
                            <td>{{ order.orderId }}</td>
                            <td>{{ order.registeredCompanyName }}</td>
                            <td>{{ order.insertedOn }}</td>
                            <td>{{ order.expectedDeliveryDate }}</td>
                            <td>{{ order.fleetNumber }}</td>
                            <td>{{ order.driver }}</td>
                            <td>{{ order.customerPurchaseOrder }}</td>
                            <td>{{ order.sbo }}</td>
                            <td>{{ order.totalAsString }}</td>
                            <td>{{ order.description }}</td>
                            <td>
                                <input type="number" v-model="order.sequenceNumber" @blur="onSequenceInput(order)"/>
                            </td>
<!--                            <td>-->
<!--                                <div class="dropdown">-->
<!--                                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">-->
<!--                                        Actions-->
<!--                                    </button>-->
<!--                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu1">-->
<!--                                        <button class="dropdown-item" @click="onViewOrderItemClick(order)">-->
<!--                                            View Order Items-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </td>-->
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-primary" @click="onBackClick" v-if="!loading">
                            Back
                        </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary float-right" @click="saveSequence" v-if="!loading" :disabled="sequenceNumberDuplicationErrorMessage !== null && sequenceNumberDuplicationErrorMessage !== ''">
                            Save Sequence
                        </button>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <success-modal
            :modalHeading="'Success'"
            :elementId="'successModal'"
            :modalMessage="successMessage"
            :showModal="showSuccessMessage"
            @okClicked="onSuccessModalOkClick"></success-modal>

    <div class="modal fade" :id="orderItemsModalId" tabindex="-1" role="dialog" :aria-labelledby="orderItemsModalId + 'Label'" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="orderItemsModalId + 'Label'">Order Items - #{{selectedOrder.orderId}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onOrderItemsModalClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <order-items-table
                            :orderId="selectedOrder.orderId"
                            :orderTotal="selectedOrder.totalAmount"></order-items-table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" @click="onOrderItemsModalClose">OK</button>
                </div>
            </div>
        </div>
    </div>

</div>
